import { createSlice } from "@reduxjs/toolkit";
import { BannerSize } from "web/script/utils/app-banner-campaign";
var appDownloadBanner = createSlice({
  name: "appDownloadBanner",
  initialState: {
    isVisible: Boolean(false),
    bannerSize: BannerSize.None,
    desktopBannerVisible: false
  },
  reducers: {
    bannerHidden: function bannerHidden(state) {
      state.isVisible = false;
      state.bannerSize = BannerSize.None;
    },
    bannerVisible: function bannerVisible(state) {
      state.isVisible = true;
    },
    setBannerSize: function setBannerSize(state, action) {
      state.bannerSize = action.payload;
    },
    setDesktopBannerVisible: function setDesktopBannerVisible(state, action) {
      state.desktopBannerVisible = action.payload;
    }
  }
});
var _appDownloadBanner$ac = appDownloadBanner.actions,
    bannerHidden = _appDownloadBanner$ac.bannerHidden,
    bannerVisible = _appDownloadBanner$ac.bannerVisible,
    setBannerSize = _appDownloadBanner$ac.setBannerSize,
    setDesktopBannerVisible = _appDownloadBanner$ac.setDesktopBannerVisible;
export { bannerHidden, bannerVisible, setBannerSize, setDesktopBannerVisible };
export default appDownloadBanner.reducer;